import { App } from './app'

const hud = document.getElementById('hud')
const panel = document.getElementById('panel')
const enter = document.getElementById('enter-vr')

if (!(hud && panel && enter instanceof HTMLButtonElement)) {
  throw new Error('index.html is missing #hud, #panel or #enter-vr')
}

const app = new App(hud, panel, enter)
window.addEventListener('beforeunload', () => app.save())

if (import.meta.env.DEV) {
  // Console handle: __rocketman.tick(ms) steps one frame, __rocketman.state
  // reads the pilot. Invaluable when a tumble is too fast to watch live.
  ;(window as unknown as Record<string, unknown>).__rocketman = app
}
